import { defineStore } from "pinia";

export interface InitialSetupData {
  email: string;
  code: string;
  hasPassword: boolean;
  optInEmailNotifications?: boolean;
  optInPhoneNotifications?: boolean;
}

export const useInitialSetupStore = defineStore("initialSetup", {
  state: () => ({
    setupData: {} as InitialSetupData
  }),
  persist: {
    storage: sessionStorage,
    pick: ["setupData"]
  },
  actions: {
    clearSetupData() {
      this.setupData = {
        email: "",
        code: "",
        hasPassword: false
      };
    }
  }
});
